module.exports = __webpack_public_path__ + "static/media/ogg.6689705a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/ogg.svg
// module id = 1693
// module chunks = 17